import { Ban, Flag, UserCheck, Users } from 'lucide-react'
import React, { useCallback, useEffect, useState } from 'react'
import Filters from '../components/Filters'
import Table from '../components/Table'
import { useDispatch, useSelector } from 'react-redux'
import { GetUsersCountAPI } from '../redux/actions/user-management/GetCountAction'
import { PulseLoader } from 'react-spinners'
import { UsersListApi } from '../redux/actions/user-management/GetUsersListAction'
import { useLocation } from 'react-router-dom'

const UserManagement = () => {

    const dispatch = useDispatch();
    const location = useLocation();

    const { response, loading, error } = useSelector((state) => state.usersCount)

    const { response: listResponse, loading: listloading, error: listError } = useSelector((state) => state.usersList)

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [items, setItems] = useState(5);
    const [search, setSearch] = useState('');
    const [dataList, setDataList] = useState([]);
    const [date, setDate] = useState('');
    const [status, setStatus] = useState('');
    const [limit, setLimit] = useState(5);
    const [deleted, setDeleted] = useState(false);

    const [searchInput, setSearchInput] = useState('');
    const [dateInput, setDateInput] = useState('');
    const [statusInput, setStatusInput] = useState('');

    const columns = ['User', 'Email', 'Status', 'Registeration', 'Actions'];

    const fetchUsersCount = () => {
        dispatch(GetUsersCountAPI());
    }

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const fetchUsersList = useCallback(() => {
        dispatch(UsersListApi(currentPage, limit, search, date, status));
    }, [currentPage, limit, search, date, status, dispatch, deleted]);

    useEffect(() => {
        fetchUsersCount()
    }, [dataList])

    useEffect(() => {
        if (location.pathname === '/admin-dashboard/user-management') {
            setCurrentPage(1);
            setLimit(5);
        }
    }, [location.pathname])

    useEffect(() => {
        fetchUsersList()
    }, [currentPage, limit, search, date, status, fetchUsersList, deleted])

    useEffect(() => {
        if (listResponse?.status === true) {
            setCurrentPage(listResponse?.data?.currentPage);
            setTotalPages(listResponse?.data?.totalPages);
            setItems(listResponse?.data?.setItems);
            setDataList(listResponse?.data?.list);
        }
    }, [listResponse])

    return (
        <>

            {loading || listloading
                ? (
                    <div style={{ height: '70vh' }} className='d-flex align-items-center justify-content-center'>
                        <PulseLoader size={25} color="#0f0a30" />
                    </div>
                ) : error || listError ? (
                    <div style={{ height: '70vh' }} className='d-flex align-items-center justify-content-center'>
                        <p className='text-danger'>Something went wrong</p>
                    </div>
                ) :
                    <section className='main-section common_section spacer'>
                        <div className='container'>
                            <div className='row gy-4'>
                                <div className="col-12">
                                    <div className="row gx-4 gy-4">
                                        <div className="col-sm-6 col-md-4 col-xl-3">
                                            <div className="dash-num-info-cards">
                                                <div className="dash-num-info-cards-header">
                                                    <div className="num-info-content-box">
                                                        <h2>Total Users</h2>
                                                        <span className="num-values">{response?.data?.totalUser}</span>
                                                    </div>
                                                    <div className="num-info-icon-box">
                                                        <Users />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-6 col-md-4 col-xl-3">
                                            <div className="dash-num-info-cards">
                                                <div className="dash-num-info-cards-header">
                                                    <div className="num-info-content-box">
                                                        <h2>Active Users</h2>
                                                        <span className="num-values">{response?.data?.activeUser}</span>
                                                    </div>
                                                    <div className="num-info-icon-box">
                                                        <UserCheck />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-6 col-md-4 col-xl-3">
                                            <div className="dash-num-info-cards">
                                                <div className="dash-num-info-cards-header">
                                                    <div className="num-info-content-box">
                                                        <h2>Flagged Users</h2>
                                                        <span className="num-values">{response?.data?.flaggedUser}</span>
                                                    </div>
                                                    <div className="num-info-icon-box">
                                                        <Flag />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-6 col-md-4 col-xl-3">
                                            <div className="dash-num-info-cards">
                                                <div className="dash-num-info-cards-header">
                                                    <div className="num-info-content-box">
                                                        <h2>Banned Users</h2>
                                                        <span className="num-values">{response?.data?.bannedUser}</span>
                                                    </div>
                                                    <div className="num-info-icon-box">
                                                        <Ban />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Filters
                                    searchInput={searchInput}
                                    setSearchInput={setSearchInput}
                                    dateInput={dateInput}
                                    setDateInput={setDateInput}
                                    statusInput={statusInput}
                                    setStatusInput={setStatusInput}
                                    setSearch={setSearch}
                                    setDate={setDate}
                                    setStatus={setStatus}
                                    handleSearchClick={(searchValue, dateValue, statusValue) => {
                                        setSearch(searchValue);
                                        setDate(dateValue);
                                        setStatus(statusValue);
                                        setCurrentPage(1);
                                    }}
                                />
                                <div className="col-12">
                                    <Table
                                        title='Users'
                                        tableData={dataList}
                                        setDataList={setDataList}
                                        limit={limit}
                                        items={items}
                                        columns={columns}
                                        totalPages={totalPages}
                                        currentPage={currentPage}
                                        handlePageChange={handlePageChange}
                                        setLimit={setLimit}
                                        setDeleted={setDeleted}
                                    />
                                </div>

                            </div>
                        </div>
                    </section>
            }
        </>
    )
}

export default UserManagement